import { GenericResource, IHttpAgent } from '@sparelabs/http-client-utils'
import {
  IAppointmentAvailabilityQueryParams,
  IAppointmentAvailabilityResponse,
  IAppointmentTypePatchBody,
  IAppointmentTypePostBody,
  IAppointmentTypeResponse,
  IListAppointmentTypeQueryParams,
} from '../types'
import { Resources } from './ResourcesType'

export class AppointmentTypeResource extends GenericResource<
  IAppointmentTypeResponse,
  IListAppointmentTypeQueryParams,
  IAppointmentTypePatchBody,
  IAppointmentTypePostBody
> {
  public get = this.buildGet()
  public list = this.buildList()
  public post = this.buildPost()
  public patch = this.buildPatch()
  constructor(agent: IHttpAgent) {
    super(Resources.AppointmentTypes, agent)
  }

  public async getAvailability(
    appointmentTypeId: string,
    params: IAppointmentAvailabilityQueryParams,
  ): Promise<IAppointmentAvailabilityResponse> {
    const response = await this.agent.get<IAppointmentAvailabilityResponse>(
      `${this.resource}/${appointmentTypeId}/availability`,
      { params },
    )
    return response.data
  }
}
